import PropTypes from 'prop-types';

const IframeMessageSender = function IframeMessageSender(props) {
    const {
        iframemessage, link,
    } = props;

    //  post message to parent window
    //  https://medium.com/@crookse/cross-domain-communication-parent-window-and-child-iframe-aaf90fcb3e26
    window.parent.postMessage(
        {
            message: iframemessage,
        },
        link,
    );

    return (null);
};

IframeMessageSender.propTypes = {
    link: PropTypes.string.isRequired,
    iframemessage: PropTypes.string.isRequired,
};

IframeMessageSender.defaultProps = {
};

export default IframeMessageSender;
